import React from "react";
import ReactDOM from "react-dom";
import "./invite-dialog.css";
import {toast} from "react-toastify";

export default function InviteDialog({ title, link, onClose }) {
    const copyToClipboard = () => {
        navigator.clipboard.writeText(link);
        toast.success("Copied Link!")
        onClose();
    };

    return ReactDOM.createPortal(
        <div className="dialog-overlay" onClick={onClose}>
            <div className="dialog-container" onClick={(e) => e.stopPropagation()}>
                <div className="dialog-header">{title}</div>
                <div className="dialog-link-container">
                    <span className="dialog-link">{link}</span>
                </div>
                <div className="dialog-buttons">
                    <button className="copy-button" onClick={copyToClipboard}>Copy</button>
                </div>
            </div>
        </div>,
        document.body
    );
}
